import { atom } from 'recoil';
import { StaticPage } from '../../domain/StaticPage';

export const staticPagesState = atom<StaticPage[]>({
  key: 'staticPagesState',
  default: [],
});
